import React from 'react'
import { FooterButtons } from '@mobi/betslip/Components/Common/BetCard'
import type { Tabs, Ticket } from '@core/Areas/Account/Pages/Activity/types'
import {
  ShareToBetLoopTooltip,
  useShareToBetLoopTooltip,
} from '@core/Areas/BetLoop/hooks/useShareToBetLoopTooltip'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'
import { doesClientSupportShare } from '@core/Areas/ShareBet/helpers/doesClientSupportShare'
import type { TicketShare } from '@core/Areas/ShareBet/types'
import { canAllowShareForFuturesTicket } from './helpers/canAllowShareForFuturesTicket'

const enum LocalConstants {
  ShareButtonSeenCountStorageKey = 'betloop:pending-share-tooltip-count',
}

type Props = {
  ticket: Ticket
  activeTab: Tabs
  sourceLocation?: TicketShare['share']['sourceLocation']
}

export const ShareBet: React.FC<Props> = ({
  ticket,
  activeTab,
  sourceLocation = 'transacted-bets',
}) => {
  if (
    !canAllowShareForFuturesTicket(activeTab, ticket) ||
    (activeTab !== 'pending' && !doesClientSupportShare())
  )
    return null

  return (
    <ShareButtonComponent ticket={ticket} activeTab={activeTab} sourceLocation={sourceLocation} />
  )
}

// ===============
// Local Component
// ===============

const ShareButtonComponent: React.FC<Props> = ({ ticket, activeTab, sourceLocation }) => {
  const { shareButtonRef, onShareButtonClick, handleDismissShareTooltip, isShareTooltipVisible } =
    useShareToBetLoopTooltip(LocalConstants.ShareButtonSeenCountStorageKey, activeTab === 'pending')

  const handleShareClick = () => {
    onShareButtonClick()
    openShareOutgoing({
      contextType: 'ticket',
      betSource: 'share-bet',
      share: { ticket, activeTab, ticketSequence: ticket.ticketSequence, sourceLocation },
    })
  }

  return (
    <>
      <FooterButtons.ShareButton
        ref={shareButtonRef}
        onClick={handleShareClick}
        testId='share-bet-button'
      />

      {isShareTooltipVisible && (
        <ShareToBetLoopTooltip
          triggerElRef={shareButtonRef}
          onDismissed={handleDismissShareTooltip}
        />
      )}
    </>
  )
}
